import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import './Page403.css';
import icon403 from "../../assets/403.svg";

const Page403 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="error-container flex align-items-center justify-content-center min-h-screen">
      <Card className="error-card shadow-8 w-full md:w-6 lg:w-5">
        <div className="text-center">

          <div className="mb-4">
            <img src={icon403} alt="403"/>
          </div>


          <h2 className="error-title mb-3">
            Acceso Prohibido
          </h2>

          <p className="error-message mb-5 text-lg">
            No tiene permiso para acceder a este recurso. 
            Si cree que esto es un error, comuníquese con el administrador del sistema.
          </p>

        </div>
      </Card>
    </div>
  );
};

export default Page403;
